import FuelPumpLogo from "./MinaGasLight.svg";

export const BannerTitle = () => {
  return (
    <div className="full-width row">
      <div className="center">
        <div className="inline">
          <img src={FuelPumpLogo} alt="mina-protocol-gas-station-icon" />
        </div>
        <div className="inline title">
          <strong>
            <h1>Mina Protocol</h1>
            <h1>Gas Station</h1>
          </strong>
        </div>
      </div>
    </div>
  )
};
